// extracted by mini-css-extract-plugin
export default {"burger":"navbar_burger__iBncW"};